import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BiCoinStack } from 'react-icons/bi';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { StyledItem } from './DraggableComponent.styles';
import dotsImg from '../../../assets/images/drag-dots.svg';

export function Item({ title }) {
  return (
    <StyledItem>
      <BiCoinStack className="icon-coin" />
      <IoIosCheckmarkCircleOutline className="icon-check" />
      <div className="text-box">
        <span className="title">{title}</span>
        {/* <span className="text">{text}</span> */}
      </div>

      <RxDragHandleDots2 className="icon-dots" />
    </StyledItem>
  );
}

export default function SortableItem(props) {
  const { id, title, text } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: '100%',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Item title={title} />
    </div>
  );
}
